<template>
    <div class="b1t-okraina-main-slider"  v-bind:class="{loading: !loaded}">
        <div class="container">

            <swiper ref="slides" class="swiper" :options="swiperOptions">
               
                <swiper-slide v-for="item in items" :key="item.FIELDS.ID">

                    <div v-if="item.stub !== true" :data-background="item.FIELDS.PREVIEW_PICTURE.SRC" class="swiper-lazy img" @click="onSlideClick(item)">
                        <div class="swiper-lazy-preloader"></div>
                    </div>

                    <div v-if="item.stub"  class="img">
                        <div class="swiper-lazy-preloader"></div>
                    </div>
                   
                </swiper-slide>

                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: 'b1t-okraina-main-slider',

        data() {
            return {
                swiperOptions: {
                    //autoplay: {
                    //    delay: 3000
                   //},
                    preloadImages: false,
                   
                    lazy: true,

                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                        dynamicBullets: true
                    },

                },
                items: [
                    {
                        FIELDS: {
                            ID: 0
                        },
                        stub: true
                    }
                ],
                loaded: false
            }
        },
        computed: {
            slides() {
                return this.$refs.slides.$swiper
            }
        },
        methods: {
            load() {
                return axios(this.$store.state.apiUrl + '/rest/slides.main.getlist', {
                    method: "GET"
                }).then((response) => {
                    this.items = response.data.ITEMS;
                    
                    return response;
                }).catch((error) => {
                    return error;
                })
            },
            onSlideClick(item) {

                switch (item.PROPS.TYPE.XML_ID) {
                    case "CATALOG_SECTION":
                        this.$router.push({ name: 'catalog_section', params: { id: item.PROPS.CATALOG_SECTION_ID }})
                        break;
                    case "ACTION":
                        this.$router.push({ name: 'action', params: { id: item.PROPS.ACTION_ID }})
                        break;
                    case "NEWS":
                        this.$router.push({ name: 'news_detail', params: { id: item.PROPS.NEWS_ID }})
                        break;

                
                    default:
                        break;
                }
            }
        },
        mounted(){

            this.slides.on("lazyImageReady",() => {
                this.loaded = true;
            })
            this.load();
           
        },
        updated() {
            this.slides.lazy.loadInSlide(0);
        }
        
    }
</script>

<style lang="scss">

    .b1t-okraina-main-slider {
        
        .img {
            height: 0px;
            padding-top: 36.53%;
            background-size: cover;
            background-position: center center;
        }
       
    }

    .b1t-okraina-main-slider.loading {
        .swiper-pagination {
            display: none;
        }
    }

    

    @media (max-width: 767px) {
        .b1t-okraina-main-slider .container{
            padding-left: 0px;
            padding-right: 0px;
        }
    }
</style>